import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'Inicio',
    path: '/'
  }, {
    name: 'Registro',
    path: '/registro'
  }, {
    name: 'Juego',
    path: '/juego'
  }, {
    name: 'Manual',
    path: '/manual'
  }, {
    name: 'Biblioteca',
    path: '/biblioteca'
  }, {
    name: 'Comunidad',
    path: '/comunidad'
  }];
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <nav className="bg-white shadow-md" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="flex justify-between h-16" data-id="element-94">
          <div className="flex items-center" data-id="element-95">
            <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-96">
              <span className="text-xl font-bold text-blue-600" data-id="element-97">
                Tu Nueva Vida
              </span>
            </Link>
          </div>
          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-98">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`px-3 py-2 rounded-md text-sm font-medium ${location.pathname === item.path ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`} data-id="element-99">
                {item.name}
              </Link>)}
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-100">
            <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-blue-50 focus:outline-none" data-id="element-101">
              {isMenuOpen ? <XIcon size={24} data-id="element-102" /> : <MenuIcon size={24} data-id="element-103" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-104">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-105">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === item.path ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-600'}`} onClick={() => setIsMenuOpen(false)} data-id="element-106">
                {item.name}
              </Link>)}
          </div>
        </div>}
    </nav>;
};
export default Navbar;